import { all } from "redux-saga/effects";
import {
  createLiveSessionRequest,
  createLiveSessionWatcher,
  setLiveSessionStateRequest,
  setLiveSessionStateWatcher,
} from "./liveSession";

export {
  createLiveSessionRequest,
  createLiveSessionWatcher,
  setLiveSessionStateRequest,
  setLiveSessionStateWatcher,
};

export default function* defaultSaga() {
  yield all([createLiveSessionWatcher(), setLiveSessionStateWatcher()]);
}
